export default {
  // GET_CATEGORIES: ({ page = 1, rowsPerPage = 10 }) => `attributes/asset-class/?page=${page}&page_size=${rowsPerPage}`,
  GET_AUDIT_SUPPLIERS: 'core/suppliers/',
  CREATE_CATEGORY: 'customers/create/',
  UPDATE_CATEGORY: (id) => `customers/${id}/update/`,
  DELETE_CATEGORY: (id) => `customers/${id}/delete/`,
};
